export default __webpack_public_path__ + "7d87328455fe50d2f2dc3c12f5ef0ce8.png";